export default __webpack_public_path__ + "static/static-asset-no-credit-check-people-cb50f1024a36fe3fbe0d199555cd01ef.svg";